export const cardImage = {
    showRoundedCardImage: {
        enabled: true,
        _description: 'Displays rounder borders with shadow around the card image.',
    },
};
